var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { useFormContext, } from "react-hook-form";
// slate
import { Node } from "slate";
import slate, { serialize } from "remark-slate";
import markdown from "remark-parse";
import { unified } from "unified";
// components
import { ErrorMessage } from "../../../Atoms";
import { WYSIWYG } from "../../../Organisms";
import { Box } from "@mui/material";
import { useIsMounted } from "../../../../hooks";
var HookWYSIWYG = function (_a) {
    var fieldName = _a.fieldName, controls = _a.controls, rules = _a.rules, _b = _a.savedValue, savedValue = _b === void 0 ? "" : _b, dialogProps = _a.dialogProps, disabled = _a.disabled, placeholder = _a.placeholder, _c = _a.showCharCount, showCharCount = _c === void 0 ? false : _c, helperNode = _a.helperNode, maxLength = _a.maxLength;
    var _d = __read(useState([]), 2), descendants = _d[0], setDescendants = _d[1];
    var isMounted = useIsMounted();
    var _e = useFormContext(), setValue = _e.setValue, setError = _e.setError, watch = _e.watch, clearErrors = _e.clearErrors, register = _e.register, formState = _e.formState, errors = _e.formState.errors, trigger = _e.trigger, getFieldState = _e.getFieldState;
    var body = watch(fieldName);
    var _f = __read(useState(false), 2), dataLoaded = _f[0], setDataLoaded = _f[1];
    /**
     * convert markdown to something slate understands
     */
    var parseMarkdownToSlate = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, unified().use(markdown).use(slate).process(body)];
                case 1:
                    data = _b.sent();
                    if (isMounted()) {
                        setDescendants(data.result);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    console.error("failed to parse body text.");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    /**
     * Use form state to populate editor state after initial load of data
     */
    useEffect(function () {
        if (!dataLoaded && body !== null && body !== undefined) {
            parseMarkdownToSlate();
            setDataLoaded(true);
        }
    }, [body]);
    /**
     * Serialize and store markdown content in form state
     */
    var onChange = function (newDescendants) {
        var plainLength = newDescendants
            .map(function (n) { return Node.string(n); })
            .join("\n").length;
        var markdown = "";
        if (plainLength) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            markdown = newDescendants.map(function (v) { return serialize(v); }).join("\n");
        }
        // when wysiwyg is instantiated with content, this gets triggered giving a false isDirty indication
        if (savedValue !== markdown.slice(0, -1)) {
            setValue(fieldName, markdown, {
                shouldDirty: true,
                shouldTouch: true,
            });
        }
        // when isTouched, do required validation if defined
        var _a = getFieldState(fieldName, formState), isTouched = _a.isTouched, error = _a.error;
        if (rules && isTouched) {
            if ((rules === null || rules === void 0 ? void 0 : rules.required) && plainLength === 0) {
                var message = rules.required.message;
                setError(fieldName, {
                    type: "required",
                    message: message,
                });
            }
            else if (maxLength &&
                (rules === null || rules === void 0 ? void 0 : rules.maxLength) &&
                plainLength >
                    (rules === null || rules === void 0 ? void 0 : rules.maxLength).value) {
                var message = "".concat(rules.maxLength.message, " (").concat(plainLength, ")");
                setError(fieldName, {
                    type: "maxLength",
                    message: message,
                });
            }
            else if (error) {
                clearErrors(fieldName);
            }
        }
    };
    // triggers validation on field
    var onBlur = function () {
        trigger(fieldName);
    };
    var error = getFieldState(fieldName, formState).error;
    // register with react-hook-form to track errors and data
    register(fieldName, rules);
    return (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ className: "WYSIWYG", "data-testid": "hook-wysiwyg" }, { children: _jsx(WYSIWYG, { dialogProps: dialogProps, editorStyles: {
                        minHeight: "6em",
                    }, readOnly: disabled, forceUpdateData: descendants, error: !!error, controls: controls, onBlur: onBlur, onChange: onChange, placeholder: placeholder, helperNode: helperNode, showCharCount: showCharCount, maxLength: maxLength }) })), _jsx(ErrorMessage, { errors: errors, name: fieldName })] }));
};
export default HookWYSIWYG;
